export default function userReducer(state = {user: {},isLoggedIn: false}, action){

    switch (action.type) {
      case 'ADD_USER':
  
        const {
          username,
          email
        } = action.user

        const currentUser = {
          username: username,
          email: email
        }
        
      return {...state, user: currentUser, isLoggedIn: true}
      
      default:
        return state;
    }
};